import { FormControlLabel } from '@mui/material';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import KogCheckBoxControlled from '@/main/components/shared/checkbox/checkBoxControlled';
import KogCheckbox from '@/main/components/shared/checkbox/kogCheckbox';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import WrapperQuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';

import { IMAGE_DEFAULT } from '@/main/services/constants';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { usePartTypeReducer } from '@/main/store/partType';

import { IQuoteNoSupplierAssignedItemResponse } from '../typesModalRequoteClaim';
import * as S from './styles';
import { IRequoteClaim } from '../modalRequoteClaim';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import { Controls } from '@/main/services/constants/constantsControl';

interface ISectionRequoteQuoteProps {
  fieldsQuote: IQuoteNoSupplierAssignedItemResponse[];
  isLoadingParts: boolean;
  maxDeadline: number;
  minDeadline: number;
}

function SectionRequoteQuote({
  fieldsQuote,
  isLoadingParts,
  maxDeadline,
  minDeadline
}: ISectionRequoteQuoteProps) {
  const SHOW_DROPDOWN_PART_TYPE = useKogControlElementId(Controls.IdSearchProcurementRequotePartType)

  const { partType: partTypeReducer } = usePartTypeReducer();

  type keyFieldsItems = keyof IQuoteNoSupplierAssignedItemResponse;
  const nameField = (name: keyFieldsItems, index: number) => `sectionQuote.parts.${index}.${name}`;

  const {
    control,
    setValue,
  } = useFormContext<IRequoteClaim>();


  const allCheckboxesSelected = useMemo(() => {
    if (isNullUndefined(fieldsQuote)) return false;

    return fieldsQuote.every(item => item.isSelected);
  }, [JSON.stringify(fieldsQuote)])

  function handleToggleCheckboxAll() {
    const isAllCheckboxesSelected = fieldsQuote.every(item => item.isSelected);
    fieldsQuote.forEach((item, index) => {
      setValue(`sectionQuote.parts.${index}.isSelected`, !isAllCheckboxesSelected);
    });
  }

  const isDisabledPartTypeDrop = isNullUndefined(partTypeReducer.data) || partTypeReducer.data.length === 1;

  return (
    <S.Container>
      {fieldsQuote.length > 0 &&
        <S.Headerpart>
          <S.HeaderTitle>{getTranslateByKey('information.unassignedParts')}</S.HeaderTitle>
          <S.AreaSelectAll>
            <FormControlLabel
              label=''
              labelPlacement='start'
              control={
                <KogCheckbox
                  id={`id-createOrder-checkbox-selectAll-section-quote`}
                  checked={allCheckboxesSelected}
                  value={allCheckboxesSelected}
                  onChange={() => handleToggleCheckboxAll()}
                />}
            />
          </S.AreaSelectAll>
        </S.Headerpart>
      }

      {fieldsQuote.map((item, index) => (
        <S.RowPart key={item.guidQuoteItem} >
          <S.ImagePart src={IMAGE_DEFAULT} />
          <S.AreaTitlePart>
            <WrapperQuoteProcurementPartInfo
              data={item.quoteProcurementPartInfo}
              renderType="column"
              isTooltip
            />
            {SHOW_DROPDOWN_PART_TYPE && (
              <KogAutoCompleteControlled
                id="id-createOrder-select-partType"
                nameCustom={nameField("partType", index)}
                isDefaultValueUnique
                valueDefaultKey={item.idPartType}
                setValueCustom={setValue}
                label=''
                placeholder={getTranslateByKey('information.partTypes')}
                control={control}
                rulesCustom={{ required: false }}
                options={partTypeReducer.data}
                isLoading={partTypeReducer.isLoading}
                disabled={isDisabledPartTypeDrop}
                onChangeCustom={() => { }}
              />
            )}
          </S.AreaTitlePart>
          <S.Quantity>1</S.Quantity>

          <KogCheckBoxControlled
            id={`id-createOrder-checkbox-select-${item.guidQuoteItem}`}
            nameCustom={nameField("isSelected", index)}
            control={control}
            label=''
          />
        </S.RowPart>
      ))}
    </S.Container>
  )
}

export default SectionRequoteQuote